import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { SharedModule } from '../_shared/shared.module';
import { ResolveSettingsComponent, ResolveActionConfigComponent, RequestRefundSettingsComponent } from '.';
import { ResolveSettingsRoutingModule } from './resolve-settings.routing';

@NgModule({
  declarations: [ResolveSettingsComponent, ResolveActionConfigComponent, RequestRefundSettingsComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    ResolveSettingsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgMultiSelectDropDownModule,
    NgxSmartModalModule.forChild(),
  ],
  providers: [],
  bootstrap: [],
})
export class ResolveSettingsModule {}
